import { CryptoRewardsPaneMode } from 'components/features/rewards/rewardsPane/types/paneState'
import { CryptoRewardsPaneReducer } from 'components/features/rewards/rewardsPane/types/store'
import { State } from 'interfaces/state'

export function getPaneReducerStateSelector (storeState: State): CryptoRewardsPaneReducer<CryptoRewardsPaneMode> {
  return storeState.data.cryptoRewardsPane
}
